import { Button, Modal } from "antd";
import React from "react";

interface IModal {
  open: boolean;
  handleOk?: () => void;
  handleCancel?: () => void;
  handleReset?: () => void;
  title: string;
  children?: React.ReactNode;
  confirmBtnText?: string;
  cancelBtnTxt?: string;
  customActionBtnTxt?: string;
  showFooter?: boolean;
}

const ModalContainer = ({
  open,
  handleCancel,
  handleOk,
  handleReset,
  children,
  title,
  confirmBtnText,
  customActionBtnTxt,
  cancelBtnTxt,
  showFooter = true,
}: IModal) => {
  const footerContent = (
    <>
      {customActionBtnTxt && (
        <Button onClick={handleReset}>{customActionBtnTxt}</Button>
      )}

      <Button key="submit" type="primary" onClick={handleOk}>
        {confirmBtnText}
      </Button>

      <Button key="back" onClick={handleCancel}>
        {cancelBtnTxt}
      </Button>
    </>
  );

  return (
    <Modal
      open={open}
      title={title}
      onOk={handleOk}
      onCancel={handleCancel}
      footer={showFooter ? footerContent : null}
    >
      <p>{children}</p>
    </Modal>
  );
};

export default ModalContainer;
